import { useCallback, useMemo } from "react";
import {
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
  gridPageSizeSelector,
  gridPageSelector
} from "@mui/x-data-grid-pro";
import { useTheme } from "@mui/material";
import { StyledPagination, makePaperStyles } from "./DataTablePagination.styles";

export const DataTablePagination = () => {
  const theme = useTheme();
  const apiRef = useGridApiContext();
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowsPerPageLabel = useGridSelector(apiRef, (api: typeof apiRef) =>
    api.current.getLocaleText("paginationRowsPerPage")
  );

  const pageSizeOptions = useMemo(() => {
    return [
      10,
      ...(rowCount > 10 ? [25] : []),
      ...(rowCount > 25 ? [50] : []),
      ...(rowCount > 50 ? [100] : [])
    ];
  }, [rowCount]);

  const handlePageChange = useCallback(
    (_: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
      apiRef.current.setPage(newPage);
    },
    []
  );

  const handleRowsPerPageChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newPageSize = parseInt(event.target.value, 10);
    apiRef.current.setPageSize(newPageSize);
  }, []);

  return (
    <StyledPagination
      component="div"
      rowsPerPageOptions={pageSizeOptions}
      labelRowsPerPage={rowsPerPageLabel}
      count={rowCount}
      page={page}
      onPageChange={handlePageChange}
      rowsPerPage={pageSize}
      onRowsPerPageChange={handleRowsPerPageChange}
      slotProps={{
        select: {
          MenuProps: {
            slotProps: {
              paper: {
                sx: makePaperStyles(theme)
              }
            }
          }
        }
      }}
    />
  );
};
